/**
 * DO NOT MODIFY
 * This file is generated by StashInvest/product-events
 * To open an issue, go to https://github.com/StashInvest/product-events/issues/new/choose
 */

import Event from './../event.js';
import { v4_CONTEXT } from './properties.js';
import { v4_SubscriptionPlanConfirm_ViewedProperties } from './properties.js';
import { v4_SubscriptionPlanNextSteps_ViewedProperties } from './properties.js';
import { v4_SubscriptionPlan_ClickedProperties } from './properties.js';
import { v4_SubscriptionPlan_SubmittedProperties } from './properties.js';
const ObjectType = {
    AccountAgreement: 'AccountAgreement',
    AccountDetails: 'AccountDetails',
    AccountLock: 'AccountLock',
    AccountOpen: 'AccountOpen',
    AccountSetup: 'AccountSetup',
    AddAccount: 'AddAccount',
    Address: 'Address',
    AddressEntry: 'AddressEntry',
    AdvisoryEsig: 'AdvisoryEsig',
    AiChat: 'AiChat',
    AiChatAgentLink: 'AiChatAgentLink',
    AiChatCTA: 'AiChatCTA',
    AiChatDisclosureLink: 'AiChatDisclosureLink',
    AiChatEntryPoint: 'AiChatEntryPoint',
    AiChatFlag: 'AiChatFlag',
    AiChatSuggestedTopic: 'AiChatSuggestedTopic',
    AppSession: 'AppSession',
    Application: 'Application',
    AutoStash: 'AutoStash',
    AutoStashDetails: 'AutoStashDetails',
    AutoStashDisable: 'AutoStashDisable',
    AutoStashDisableContinue: 'AutoStashDisableContinue',
    AutoStashDisableSpeedbump: 'AutoStashDisableSpeedbump',
    AutoStashEnable: 'AutoStashEnable',
    AutoStashHome: 'AutoStashHome',
    AutoStashModify: 'AutoStashModify',
    AutoStashModifyResult: 'AutoStashModifyResult',
    AutoStashModule: 'AutoStashModule',
    AutoStashPause: 'AutoStashPause',
    AutoStashPauseSetup: 'AutoStashPauseSetup',
    AutoStashPauseSpeedbump: 'AutoStashPauseSpeedbump',
    AutoStashProjection: 'AutoStashProjection',
    AutoStashRemoveAllocation: 'AutoStashRemoveAllocation',
    AutoStashResume: 'AutoStashResume',
    AutoStashUpdate: 'AutoStashUpdate',
    AvibraEligibility: 'AvibraEligibility',
    AvibraPlan: 'AvibraPlan',
    BankAccount: 'BankAccount',
    BankCard: 'BankCard',
    BankCardDelivery: 'BankCardDelivery',
    BankHome: 'BankHome',
    BankPinCode: 'BankPinCode',
    BrowseInvestments: 'BrowseInvestments',
    BundleOptions: 'BundleOptions',
    Buy: 'Buy',
    BuyAmountEntry: 'BuyAmountEntry',
    BuyConfirmation: 'BuyConfirmation',
    BuyOptions: 'BuyOptions',
    BuySetup: 'BuySetup',
    BuySetupResults: 'BuySetupResults',
    BuySucceeded: 'BuySucceeded',
    CancelSubscriptionResults: 'CancelSubscriptionResults',
    CardSpend: 'CardSpend',
    Category: 'Category',
    ChooseDocument: 'ChooseDocument',
    CoachFeed: 'CoachFeed',
    CoachModule: 'CoachModule',
    Collection: 'Collection',
    ConfirmPII: 'ConfirmPII',
    ContactStashSupport: 'ContactStashSupport',
    ContactStashSupportStart: 'ContactStashSupportStart',
    ContributionSetup: 'ContributionSetup',
    Deposit: 'Deposit',
    DepositSetup: 'DepositSetup',
    DirectDepositCard: 'DirectDepositCard',
    DiversificationAnalysis: 'DiversificationAnalysis',
    DiversificationAnalysisAssetClass: 'DiversificationAnalysisAssetClass',
    DiversificationAnalysisInfo: 'DiversificationAnalysisInfo',
    DividendEarn: 'DividendEarn',
    Document: 'Document',
    Email: 'Email',
    EmploymentInfo: 'EmploymentInfo',
    EmploymentInfoEntry: 'EmploymentInfoEntry',
    Experiment: 'Experiment',
    ExternalAccount: 'ExternalAccount',
    ExternalAccountBankDetails: 'ExternalAccountBankDetails',
    ExternalAccountChasePartial: 'ExternalAccountChasePartial',
    ExternalAccountChooseBank: 'ExternalAccountChooseBank',
    ExternalAccountLink: 'ExternalAccountLink',
    ExternalAccountLinkAccountNum: 'ExternalAccountLinkAccountNum',
    ExternalAccountLinkAutoConfirm: 'ExternalAccountLinkAutoConfirm',
    ExternalAccountLinkFailed: 'ExternalAccountLinkFailed',
    ExternalAccountLinkPendingMicros: 'ExternalAccountLinkPendingMicros',
    ExternalAccountLinkPrimer: 'ExternalAccountLinkPrimer',
    ExternalAccountLinkProcessing: 'ExternalAccountLinkProcessing',
    ExternalAccountLinkSetup: 'ExternalAccountLinkSetup',
    ExternalAccountLinkSetupResults: 'ExternalAccountLinkSetupResults',
    ExternalAccountLinkStart: 'ExternalAccountLinkStart',
    FinraAffiliate: 'FinraAffiliate',
    FirstDeposit: 'FirstDeposit',
    FraudScreen: 'FraudScreen',
    Goal: 'Goal',
    GoalCreateCancel: 'GoalCreateCancel',
    GoalCreateCancelOption: 'GoalCreateCancelOption',
    GoalCreateName: 'GoalCreateName',
    GoalCreateNameEntry: 'GoalCreateNameEntry',
    GoalCreateStart: 'GoalCreateStart',
    GoalCreateTargets: 'GoalCreateTargets',
    GoalDetailDelete: 'GoalDetailDelete',
    GoalDetailDeleteOption: 'GoalDetailDeleteOption',
    GoalDetailEdit: 'GoalDetailEdit',
    GoalDetails: 'GoalDetails',
    GoalsHome: 'GoalsHome',
    GoalsInfo: 'GoalsInfo',
    Graph: 'Graph',
    GraphTimeframe: 'GraphTimeframe',
    HodorVerification: 'HodorVerification',
    Home: 'Home',
    IDVCapture: 'IDVCapture',
    IDVCaptureConfirmation: 'IDVCaptureConfirmation',
    IDVDocumentUpload: 'IDVDocumentUpload',
    IDVEntry: 'IDVEntry',
    IDVMiskey: 'IDVMiskey',
    IDVResult: 'IDVResult',
    IdentityConfirmation: 'IdentityConfirmation',
    InAppPromoEnrollment: 'InAppPromoEnrollment',
    InternalNotification: 'InternalNotification',
    InternalNotificationAction: 'InternalNotificationAction',
    InternalNotificationDismiss: 'InternalNotificationDismiss',
    InternalTransferSetup: 'InternalTransferSetup',
    InvestAccount: 'InvestAccount',
    InvestHome: 'InvestHome',
    InvestPerformanceInfo: 'InvestPerformanceInfo',
    InvestingQuestions: 'InvestingQuestions',
    InvestingQuestionsEntry: 'InvestingQuestionsEntry',
    InvestingTips: 'InvestingTips',
    Investment: 'Investment',
    InvestmentDetails: 'InvestmentDetails',
    InvoicePayment: 'InvoicePayment',
    LandingPage: 'LandingPage',
    LearnAndEarn: 'LearnAndEarn',
    LearnAndEarnAction: 'LearnAndEarnAction',
    LearnHome: 'LearnHome',
    LegacySubscriptionActivation: 'LegacySubscriptionActivation',
    LegacySubscriptionCancel: 'LegacySubscriptionCancel',
    Login: 'Login',
    MicroDepositConfirmation: 'MicroDepositConfirmation',
    MicroDepositResend: 'MicroDepositResend',
    MicrosSend: 'MicrosSend',
    MoneyMovement: 'MoneyMovement',
    MoneyMovementConfirmation: 'MoneyMovementConfirmation',
    MoneyMovementDestination: 'MoneyMovementDestination',
    MoneyMovementLimits: 'MoneyMovementLimits',
    MoneyMovementResults: 'MoneyMovementResults',
    MoneyMovementSetup: 'MoneyMovementSetup',
    MoneyMovementSource: 'MoneyMovementSource',
    MyGoals: 'MyGoals',
    MyGoalsModule: 'MyGoalsModule',
    MyStash: 'MyStash',
    MyStashHome: 'MyStashHome',
    MyStashHomeAccountsSummary: 'MyStashHomeAccountsSummary',
    MyStashHomeEligibleAccounts: 'MyStashHomeEligibleAccounts',
    MyStashModule: 'MyStashModule',
    MyStashModuleInfo: 'MyStashModuleInfo',
    MyStashSection: 'MyStashSection',
    MyStashSectionFailed: 'MyStashSectionFailed',
    Offer: 'Offer',
    OfferAccepted: 'OfferAccepted',
    OtherAccountsInfo: 'OtherAccountsInfo',
    PIIEntry: 'PIIEntry',
    PaywallStatus: 'PaywallStatus',
    PersonalDetails: 'PersonalDetails',
    PersonalDetailsEntry: 'PersonalDetailsEntry',
    PersonalPortfolioInfo: 'PersonalPortfolioInfo',
    Phone: 'Phone',
    PhoneEntry: 'PhoneEntry',
    PhoneOTP: 'PhoneOTP',
    PhoneOTPResend: 'PhoneOTPResend',
    PhoneVerification: 'PhoneVerification',
    Plan: 'Plan',
    PortfolioDetails: 'PortfolioDetails',
    PortfolioOverview: 'PortfolioOverview',
    PortfolioRebalance: 'PortfolioRebalance',
    PortfolioSetup: 'PortfolioSetup',
    PortfolioSetupPrimer: 'PortfolioSetupPrimer',
    PreferredPaymentMethod: 'PreferredPaymentMethod',
    ProductHighlightsModule: 'ProductHighlightsModule',
    PromoEnrollment: 'PromoEnrollment',
    PromoPayout: 'PromoPayout',
    ReactivateSubscription: 'ReactivateSubscription',
    ReactivationEntry: 'ReactivationEntry',
    ReactivationEsig: 'ReactivationEsig',
    RecurringTransactionAuthorization: 'RecurringTransactionAuthorization',
    Referral: 'Referral',
    ReferralCode: 'ReferralCode',
    ReferralHome: 'ReferralHome',
    ReferralLandingPage: 'ReferralLandingPage',
    ReferralModule: 'ReferralModule',
    ReferralRecipient: 'ReferralRecipient',
    ReferralRecipientPayout: 'ReferralRecipientPayout',
    ReferralSenderPayout: 'ReferralSenderPayout',
    ReferralShareCode: 'ReferralShareCode',
    ResumeAutoStashModule: 'ResumeAutoStashModule',
    RetirementDistributionForm: 'RetirementDistributionForm',
    RetirementHome: 'RetirementHome',
    SMSOptin: 'SMSOptin',
    SSN: 'SSN',
    SSNDuplicateAllowable: 'SSNDuplicateAllowable',
    SSNEntry: 'SSNEntry',
    SearchEntry: 'SearchEntry',
    SearchResult: 'SearchResult',
    SecurityDetails: 'SecurityDetails',
    ShareReferral: 'ShareReferral',
    SmartDeposit: 'SmartDeposit',
    SmartMixInfo: 'SmartMixInfo',
    SpecialOffers: 'SpecialOffers',
    StashWorks: 'StashWorks',
    StashWorksUserSignup: 'StashWorksUserSignup',
    StashWorksWelcomeScreen: 'StashWorksWelcomeScreen',
    StashworksAccountLink: 'StashworksAccountLink',
    StashworksEnrollmentCancel: 'StashworksEnrollmentCancel',
    StashworksMagicLink: 'StashworksMagicLink',
    StateZero: 'StateZero',
    StockBackActivation: 'StockBackActivation',
    StockBackHome: 'StockBackHome',
    StockBackPayout: 'StockBackPayout',
    StockBackRoundups: 'StockBackRoundups',
    StockBackRoundupsDisable: 'StockBackRoundupsDisable',
    StockBackRoundupsEnable: 'StockBackRoundupsEnable',
    StockParty: 'StockParty',
    StockPartyClaim: 'StockPartyClaim',
    StockPartyClaimPayout: 'StockPartyClaimPayout',
    Subscription: 'Subscription',
    SubscriptionActivation: 'SubscriptionActivation',
    SubscriptionBillingFrequency: 'SubscriptionBillingFrequency',
    SubscriptionCancel: 'SubscriptionCancel',
    SubscriptionCancelContinue: 'SubscriptionCancelContinue',
    SubscriptionDetails: 'SubscriptionDetails',
    SubscriptionEndOfFreeTrial: 'SubscriptionEndOfFreeTrial',
    SubscriptionPaymentMethod: 'SubscriptionPaymentMethod',
    SubscriptionPlan: 'SubscriptionPlan',
    SubscriptionPlanChange: 'SubscriptionPlanChange',
    SubscriptionPlanConfirm: 'SubscriptionPlanConfirm',
    SubscriptionPlanDetails: 'SubscriptionPlanDetails',
    SubscriptionPlanNextSteps: 'SubscriptionPlanNextSteps',
    SubscriptionPlanRefund: 'SubscriptionPlanRefund',
    SubscriptionReactivation: 'SubscriptionReactivation',
    SubscriptionStatus: 'SubscriptionStatus',
    TotalValueInfo: 'TotalValueInfo',
    Transfer: 'Transfer',
    TrustedContact: 'TrustedContact',
    TrustedContactEntry: 'TrustedContactEntry',
    UserAuthenticate: 'UserAuthenticate',
    UserIdLog: 'UserIdLog',
    UserIntentQuestion: 'UserIntentQuestion',
    UserProfile: 'UserProfile',
    UserSignup: 'UserSignup',
    VerifyMicros: 'VerifyMicros',
    WelcomeScreen: 'WelcomeScreen',
    WithdrawSetup: 'WithdrawSetup',
    Withdrawal: 'Withdrawal',
    ZenDeskTicket: 'ZenDeskTicket',
};

const ActionType = {
    Activated: 'Activated',
    Assigned: 'Assigned',
    Clicked: 'Clicked',
    Closed: 'Closed',
    Completed: 'Completed',
    Created: 'Created',
    Failed: 'Failed',
    Installed: 'Installed',
    Opened: 'Opened',
    Processed: 'Processed',
    Responded: 'Responded',
    Scheduled: 'Scheduled',
    Started: 'Started',
    Submitted: 'Submitted',
    Succeeded: 'Succeeded',
    Updated: 'Updated',
    Verified: 'Verified',
    Viewed: 'Viewed',
};

export function v4_SubscriptionPlanConfirm_Viewed(payload) {
    const properties = new v4_SubscriptionPlanConfirm_ViewedProperties(payload);
    const results = new Event(
        ObjectType.SubscriptionPlanConfirm,
        ActionType.Viewed,
        'v4',
        properties
    ).track();
    return {
        event: results['eventName'],
        metric: results['topicName'],
        properties: results['propertiesMap'],
        context: v4_CONTEXT,
    };
}

export function v4_SubscriptionPlanNextSteps_Viewed(payload) {
    const properties = new v4_SubscriptionPlanNextSteps_ViewedProperties(
        payload
    );
    const results = new Event(
        ObjectType.SubscriptionPlanNextSteps,
        ActionType.Viewed,
        'v4',
        properties
    ).track();
    return {
        event: results['eventName'],
        metric: results['topicName'],
        properties: results['propertiesMap'],
        context: v4_CONTEXT,
    };
}

export function v4_SubscriptionPlan_Clicked(payload) {
    const properties = new v4_SubscriptionPlan_ClickedProperties(payload);
    const results = new Event(
        ObjectType.SubscriptionPlan,
        ActionType.Clicked,
        'v4',
        properties
    ).track();
    return {
        event: results['eventName'],
        metric: results['topicName'],
        properties: results['propertiesMap'],
        context: v4_CONTEXT,
    };
}

export function v4_SubscriptionPlan_Submitted(payload) {
    const properties = new v4_SubscriptionPlan_SubmittedProperties(payload);
    const results = new Event(
        ObjectType.SubscriptionPlan,
        ActionType.Submitted,
        'v4',
        properties
    ).track();
    return {
        event: results['eventName'],
        metric: results['topicName'],
        properties: results['propertiesMap'],
        context: v4_CONTEXT,
    };
}
